import React from "react";
import { Link } from "react-router-dom";

/** Primary CTA — navigates to /signup (never opens a modal). */
export default function SignUpLink({ className, children, onClick, ...rest }) {
  return (
    <Link to="/signup" className={className} onClick={onClick} data-testid="signup-cta" {...rest}>
      {children}
    </Link>
  );
}
